import { TextField, Select, Checkbox } from "../../../../components/forms";
import UnifiedFileUpload from "../../../../components/forms/UnifiedFileUpload";
import TextArea from "../../../../components/forms/TextArea";

const RecordForm = ({
    fieldType,
    name,
    label,
    options = [],
    typeName = null,
    isRequired,
    multiple = false,
    disabled = false,
    initialFile = null,
    editable = false,
    onFileSelected,
    selectedFile,
    ...props
}) => {
    const renderField = () => {
        switch (fieldType) {
            case "text":
                return (
                    <TextField name={name} label={label} disabled={disabled} />
                );
            case "number":
                return (
                    <TextField
                        name={name}
                        label={label}
                        type="number"
                        min="0"
                        required={isRequired}
                        disabled={disabled}
                        onKeyDown={(e) => {
                            if (e.key === "-" || e.key === "e") {
                                e.preventDefault();
                            }
                        }}
                        {...props}
                    />
                );
            case "date":
                return (
                    <TextField
                        name={name}
                        label={label}
                        type="date"
                        required={isRequired}
                        disabled={disabled}
                    />
                );
            case "dropdown":
                return (
                    <Select
                        name={name}
                        label={label}
                        options={options}
                        {...props}
                        required={isRequired}
                        // value={props.value}
                        disabled={disabled}
                    />
                );
            case "file":
                return (
                    <UnifiedFileUpload
                        name={name}
                        fileType="document"
                        label={label}
                        onFileSelected={onFileSelected}
                        selectedFile={selectedFile}
                        width="100%"
                        required={isRequired}
                        multiple={multiple}
                        maxFiles={props.maxFiles || 5}
                        disabled={disabled}
                        initialFile={initialFile}
                    />
                );
            case "image":
                return (
                    <UnifiedFileUpload
                        name={name}
                        fileType="image"
                        label={label}
                        onFileSelected={onFileSelected}
                        selectedFile={selectedFile}
                        width="100%"
                        required={isRequired}
                        multiple={multiple}
                        disabled={disabled}
                        initialFile={initialFile}
                    />
                );
            case "checkbox":
                return (
                    <Checkbox
                        name={name}
                        label={label}
                        required={isRequired}
                        disabled={disabled}
                    />
                );
            case "description":
                return (
                    <TextArea
                        name={name}
                        label={label}
                        required={isRequired}
                        disabled={disabled}
                    />
                );
            default:
                return (
                    <TextField
                        name={name}
                        label={label}
                        required={isRequired}
                        disabled={disabled}
                    />
                );
        }
    };

    return <div className="my-4">{renderField()}</div>;
};

export default RecordForm;
